// extracted by mini-css-extract-plugin
export default {"wrapper":"SuggestionBox_wrapper__zrbKl","info":"SuggestionBox_info__WFxoR","cta":"SuggestionBox_cta__geexp","image":"SuggestionBox_image__CngDK"};